export default __webpack_public_path__ + "static/media/check.b3093d9b.svg";